import React from "react";
import FieldHeader from "./FieldHeader";
import TextInput from "./TextInput";

interface TextBoxProps {
  labelStr: string;
  placeholderStr: string;
  tooltipStr: string;
  number: number;
  type?: "text" | "number" | "textarea";
  value?: string;
  maxStrLength?: number;
  extraCssClass?: string;
  required?: boolean;
  onChange: (arg: any) => any | void;
  onFocus?: (arg: any) => any | void;
}

const TextBox = ({
  labelStr,
  placeholderStr,
  tooltipStr,
  number,
  type = "text",
  onChange,
  extraCssClass,
  required = false,
  ...props
}: TextBoxProps) => {
  return (
    <FieldHeader
      number={number}
      title={labelStr}
      tooltipStr={tooltipStr}
      extraCssClass={extraCssClass}
      element={
        <TextInput
          type={type}
          placeholderStr={placeholderStr}
          onChange={onChange}
          required={required}
          {...props}
        />
      }
    />
  );
};

export default TextBox;
